import React from 'react'

export function TredingDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M20.5 10.75a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-6a.75.75 0 010-1.5h5.25V11.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M2.522 5.922a.75.75 0 011.056.1l4.755 5.75 4.369-2.662a.75.75 0 01.932.122l7.408 7.75a.75.75 0 11-1.084 1.036l-6.99-7.313L8.56 13.39a.75.75 0 01-.969-.162l-5.169-6.25a.75.75 0 01.1-1.056z"
        clipRule="evenodd"
      />
    </svg>
  )
}
